module.exports = __webpack_public_path__ + "media/iconic/social-ffb21c01.svg";